__turbopack_context__.v({
  "active": "PricingPage-module__vT2PCG__active",
  "contactInfo": "PricingPage-module__vT2PCG__contactInfo",
  "contactItem": "PricingPage-module__vT2PCG__contactItem",
  "contactSection": "PricingPage-module__vT2PCG__contactSection",
  "container": "PricingPage-module__vT2PCG__container",
  "ctaButton": "PricingPage-module__vT2PCG__ctaButton",
  "ctaContent": "PricingPage-module__vT2PCG__ctaContent",
  "ctaNote": "PricingPage-module__vT2PCG__ctaNote",
  "ctaSection": "PricingPage-module__vT2PCG__ctaSection",
  "featureCard": "PricingPage-module__vT2PCG__featureCard",
  "featureIcon": "PricingPage-module__vT2PCG__featureIcon",
  "featured": "PricingPage-module__vT2PCG__featured",
  "features": "PricingPage-module__vT2PCG__features",
  "featuresGrid": "PricingPage-module__vT2PCG__featuresGrid",
  "footer": "PricingPage-module__vT2PCG__footer",
  "footerBottom": "PricingPage-module__vT2PCG__footerBottom",
  "footerContent": "PricingPage-module__vT2PCG__footerContent",
  "footerSection": "PricingPage-module__vT2PCG__footerSection",
  "glow": "PricingPage-module__vT2PCG__glow",
  "heroButtons": "PricingPage-module__vT2PCG__heroButtons",
  "logo": "PricingPage-module__vT2PCG__logo",
  "menuButton": "PricingPage-module__vT2PCG__menuButton",
  "menuIcon": "PricingPage-module__vT2PCG__menuIcon",
  "menuItem": "PricingPage-module__vT2PCG__menuItem",
  "menuItemLink": "PricingPage-module__vT2PCG__menuItemLink",
  "menuPaper": "PricingPage-module__vT2PCG__menuPaper",
  "nav": "PricingPage-module__vT2PCG__nav",
  "navContainer": "PricingPage-module__vT2PCG__navContainer",
  "navLink": "PricingPage-module__vT2PCG__navLink",
  "navLinks": "PricingPage-module__vT2PCG__navLinks",
  "networkCard": "PricingPage-module__vT2PCG__networkCard",
  "networkCta": "PricingPage-module__vT2PCG__networkCta",
  "networkGrid": "PricingPage-module__vT2PCG__networkGrid",
  "networkIcon": "PricingPage-module__vT2PCG__networkIcon",
  "planButton": "PricingPage-module__vT2PCG__planButton",
  "planDescription": "PricingPage-module__vT2PCG__planDescription",
  "planFeatures": "PricingPage-module__vT2PCG__planFeatures",
  "planName": "PricingPage-module__vT2PCG__planName",
  "planPrice": "PricingPage-module__vT2PCG__planPrice",
  "pricing": "PricingPage-module__vT2PCG__pricing",
  "pricingCard": "PricingPage-module__vT2PCG__pricingCard",
  "pricingGrid": "PricingPage-module__vT2PCG__pricingGrid",
  "pricingToggle": "PricingPage-module__vT2PCG__pricingToggle",
  "primaryButton": "PricingPage-module__vT2PCG__primaryButton",
  "providerNetwork": "PricingPage-module__vT2PCG__providerNetwork",
  "root": "PricingPage-module__vT2PCG__root",
  "secondaryButton": "PricingPage-module__vT2PCG__secondaryButton",
  "sectionHeader": "PricingPage-module__vT2PCG__sectionHeader",
  "toggleButton": "PricingPage-module__vT2PCG__toggleButton",
});
